import {Anchor} from '@mantine/core';
import React, {useState} from 'react';

import {trackEvent} from 'analytics/Analytics';
import {ANALYSIS_TOOL_ANALYTICS_ACTIONS} from 'constants/analytics-products';
import localStorage from 'LocalStorage';
import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';

const STORAGE_KEY = 'benchling.custom-code-survey-callout-dismissed';
const SURVEY_URL = 'https://airtable.com/appTg2DUKNhQlUfwR/pagIaOAtKsQVxTfdW/form';

function isDismissed(): boolean {
  return localStorage.json.getItem(STORAGE_KEY) === true;
}

export default function CustomCodeSurveyCallout(): JSX.Element | null {
  const [dismissed, setDismissed] = useState(isDismissed);

  if (dismissed) {
    return null;
  }

  const handleDismiss = (): void => {
    trackEvent(ANALYSIS_TOOL_ANALYTICS_ACTIONS.DISMISSED_CUSTOM_CODE_SURVEY_CALLOUT);
    localStorage.json.setItem(STORAGE_KEY, true);
    setDismissed(true);
  };

  const handleLinkClick = (): void => {
    trackEvent(ANALYSIS_TOOL_ANALYTICS_ACTIONS.CLICKED_CUSTOM_CODE_SURVEY_LINK);
  };

  return (
    <InlineBanner
      bannerType={InlineBannerType.INFO}
      text="Help us improve custom code"
      supportingInfo={
        <span>
          <Anchor href={SURVEY_URL} target="_blank" rel="noopener noreferrer" onClick={handleLinkClick}>
            Take a short survey
          </Anchor>{' '}
          to help us improve the developer experience.
        </span>
      }
      onDismiss={handleDismiss}
    />
  );
}
